module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h7whK"))).then(() => parcelRequire('ljYL6'));